var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "orderPage bg-grey3 align-self-center" },
    [
      !_vm.order
        ? _c(
            "div",
            { staticClass: "flex-center-center flex-column px-20 py-40" },
            [
              _vm.loading
                ? _c("div", [
                    _c(
                      "span",
                      { staticClass: "text-uppercase display-3 mb-10" },
                      [_vm._v("Chargement de la commande")]
                    ),
                    _vm._v(" "),
                    _c("span", { staticClass: "loading" }),
                  ])
                : _c("div", [
                    _c(
                      "span",
                      { staticClass: "text-uppercase display-3 mb-10" },
                      [_vm._v("Impossible d'afficher la commande ")]
                    ),
                  ]),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.order && _vm.order.loading
        ? _c(
            "div",
            { staticClass: "flex-center-center flex-column px-20 py-40" },
            [
              _c("span", { staticClass: "text-uppercase display-3 mb-10" }, [
                _vm._v("Chargement de la commande"),
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "loading" }),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.order && !_vm.order.loading
        ? _c(
            "div",
            {
              staticClass:
                "orderPage--top flex-between-center pos-sticky bg-grey3 zindex-2",
            },
            [
              _c("order-state", {
                attrs: { order: _vm.order, "is-ticket": _vm.isTicket },
              }),
              _vm._v(" "),
              _vm.order.ShopId
                ? _c("a", {
                    staticClass:
                      "fie-icon_close color-grey1 hover-opacity p-20",
                    attrs: { href: _vm.order.ShopId + "/client/orders" },
                  })
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.order
        ? _c("order-details", {
            attrs: {
              order: _vm.order,
              "show-reorder": _vm.showReorder,
              "is-ticket": _vm.isTicket,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("div", {
        staticClass: "mobile-footer bg-grey3",
        staticStyle: { "padding-top": "100px" },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }